// iife function
(function() {
    // click functionality for the desktop version of this component
    //(needed to be separated from the mobile version because of the way the mobile version is structured)
    const clickables = document.querySelectorAll('[data-da-clickable]');
    if (clickables) {
        clickables.forEach(clickable => {
            const subjectRows = document.querySelectorAll(`[data-da-subject="${clickable.getAttribute('data-da-clickable')}"]`);
            clickable.addEventListener('click', () => {
                subjectRows.forEach(subjectRow => {
                    if (subjectRow.classList.contains('hidden')) {
                        subjectRow.classList.remove('hidden');
                    }
                    else {
                        subjectRow.classList.add('hidden');
                    }
                });
            });
        });
    }

    // click functionality for the mobile version of this component
    const mobileClickables = document.querySelectorAll('[data-da-clickable-mobile]');
    if (mobileClickables) {
        mobileClickables.forEach(mobileClickable => {
            const mobileTitle = mobileClickable.querySelector('[data-da-clickable-title]');
            const mobileSeeMore = mobileClickable.querySelector('[data-da-clickable-see-more]');
            const mobileSubjects = mobileClickable.querySelector('[data-da-subjects]');
            mobileTitle.addEventListener('click', () => {
                if (mobileClickable.classList.contains('is-active')) {
                    mobileClickable.classList.remove('is-active');
                }
                else {
                    mobileClickable.classList.add('is-active');
                }
            });

            mobileSeeMore.addEventListener('click', () => {
                if (mobileSeeMore.getAttribute('data-da-clickable-see-more') === 'false') {
                    mobileSeeMore.textContent = 'See Less';
                    mobileSeeMore.setAttribute('data-da-clickable-see-more', 'true');
                    mobileSubjects.classList.remove('hidden');
                } else {
                    mobileSeeMore.textContent = 'See More';
                    mobileSeeMore.setAttribute('data-da-clickable-see-more', 'false');
                    mobileSubjects.classList.add('hidden');
                }
            });

            const mobileSubjectRows = mobileClickable.querySelectorAll('[data-da-clickable-subject-row]');
            mobileSubjectRows.forEach(mobileSubjectRow => {
                const mobileSubjectDegrees = mobileSubjectRow.querySelector('[data-da-subject-degrees]');

                mobileSubjectRow.addEventListener('click', () => {
                    if (mobileSubjectRow.getAttribute('data-da-clickable-subject-row') === 'false') {
                        mobileSubjectDegrees.classList.remove('hidden');
                        mobileSubjectRow.setAttribute('data-da-clickable-subject-row', 'true');
                        mobileSubjectRow.classList.add('is-active');
                    } else {
                        mobileSubjectRow.setAttribute('data-da-clickable-subject-row', 'false');
                        mobileSubjectDegrees.classList.add('hidden');
                        mobileSubjectRow.classList.remove('is-active');
                    }
                });
            });
        });
    }
})();
